import React, { useState } from "react";

interface ChartActionsProps {
  currentChartType: string;
  availableColumns: string[];
  currentXAxis?: string;
  currentYAxis?: string;
  onAdjust: (adjustment: Record<string, string>) => void;
}

const CHART_TYPES = [
  { value: "bar",           label: "Bar" },
  { value: "line",          label: "Line" },
  { value: "area",          label: "Area" },
  { value: "pie",           label: "Pie" },
  { value: "grouped_bar",   label: "Grouped Bar" },
  { value: "stacked_bar",   label: "Stacked Bar" },
];

export const ChartActions: React.FC<ChartActionsProps> = ({
  currentChartType,
  availableColumns,
  currentXAxis,
  currentYAxis,
  onAdjust,
}) => {
  const [chartType, setChartType]   = useState(currentChartType);
  const [xAxis, setXAxis]           = useState(currentXAxis || "");
  const [yAxis, setYAxis]           = useState(currentYAxis || "");

  const handleChange = (field: string, value: string) => {
    if (field === "chartType") setChartType(value);
    if (field === "xAxis")     setXAxis(value);
    if (field === "yAxis")     setYAxis(value);

    const adjustment: Record<string, string> = {
      [field === "chartType" ? "chart_type" : field]: value,
    };
    onAdjust(adjustment);
  };

  return (
    <div className="flex items-center gap-4 flex-wrap p-3 bg-gray-50 rounded-lg border border-gray-200">
      <div className="flex items-center gap-2">
        <label className="text-sm font-medium text-gray-600">Type:</label>
        <select
          value={chartType}
          onChange={(e) => handleChange("chartType", e.target.value)}
          className="text-sm border border-gray-300 rounded px-2 py-1 bg-white"
        >
          {CHART_TYPES.map((t) => (
            <option key={t.value} value={t.value}>{t.label}</option>
          ))}
        </select>
      </div>

      <div className="flex items-center gap-2">
        <label className="text-sm font-medium text-gray-600">X:</label>
        <select
          value={xAxis}
          onChange={(e) => handleChange("x_axis", e.target.value)}
          className="text-sm border border-gray-300 rounded px-2 py-1 bg-white"
        >
          <option value="">— auto —</option>
          {availableColumns.map((col) => (
            <option key={col} value={col}>{col}</option>
          ))}
        </select>
      </div>

      <div className="flex items-center gap-2">
        <label className="text-sm font-medium text-gray-600">Y:</label>
        <select
          value={yAxis}
          onChange={(e) => handleChange("y_axis", e.target.value)}
          className="text-sm border border-gray-300 rounded px-2 py-1 bg-white"
        >
          <option value="">— auto —</option>
          {availableColumns.map((col) => (
            <option key={col} value={col}>{col}</option>
          ))}
        </select>
      </div>
    </div>
  );
};
